<template>
  <button class="card-button">
    <!-- <i class="fa fa-credit-card card-icon"></i> -->
    <i class="fa fa-money-check card-icon"></i>
  </button>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style>
.card-icon {
  font-size: 24px !important;
  cursor: pointer;
  transition: all 0.2s;
  color: rgb(86, 100, 210) !important;
}
.card-button {
  background-color: inherit;
  border-radius: 10px;
  padding: 10px;
  border: 0px;
  transition: all 0.2s;
}
.card-button:hover .card-icon {
  transform: scale(1.3);
}
.card-button:hover {
  background-color: rgba(86, 100, 210, 0.1);
}
</style>
